import { render, staticRenderFns } from "./CampaignSortOrderNameplate.vue?vue&type=template&id=549a8c42&lang=pug"
import script from "./CampaignSortOrderNameplate.vue?vue&type=script&lang=js"
export * from "./CampaignSortOrderNameplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports